<template>
  <div class="table-msg">
    <div class="html-content" v-html="msgContent"></div>
    <div class="table-box" v-if="tableData">
      <table class="table">
        <tr class="tr table-head">
          <td v-for="(hd, index) in tableData.headers" :key="index" class="th"
            :width="(100/tableData.headers.length) + '%'" v-html="hd">
          </td>
        </tr>
        <tr v-for="(item, lindex) in tableData.rows" :key="lindex" class="tr">
          <td v-for="(td, tindex) in item" :key="tindex" class="td"
            :class="tindex===0 ? 'td-first' : ''" v-html="td"></td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import robotMsgFilter from '@/utils/robotMsgFilter';
import Utils from '@/utils/string';

export default {
  props: {
    message: {
      type: Object,
      default() {
        return {};
      },
    },

    // 消息是否处于折叠状态
    contentFold: {
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    msgContent() {
      let { content } = this.message.content;
      content = Utils.coverEmojIndex2EmojiImg(robotMsgFilter(content));
      return content;
    },
    // 表格数据
    tableData() {
      return this.message.content.table;
    },
  },

  methods: {
    // --- 先不要截断逻辑了 ---
    // 根据折叠状态，处理表格文字。
    // 注意，这里会有一个副作用：
    // 因为要先计算是不是超过 360了， 如果超了，这个时候才会 折叠，
    // 然后 折叠之后 会进一步截断。  这就会导致  最终消息卡片 的高度 进一步变小。
    getTdContent(cnt) {
      // 折叠状态时，文字要截断。
      const FOLD_TXT_NUM = 30;
      if (this.contentFold) {
        if (cnt.length > FOLD_TXT_NUM) {
          return `${cnt.substr(0, FOLD_TXT_NUM)}…`;
        }
      }
      return cnt;
    },
  },
};
</script>
<style lang="less" scoped>
.table-msg{
  @bdc: 1px solid #E2E5EA;
  .table-box{
    margin-top: 12px;
    border-radius: 6px;
    border: @bdc;
  }
  .table{
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
    border: 0;
    overflow: hidden;
    border-radius: inherit;

    .tr{
      border-bottom: @bdc;
      &:last-child{
        border-bottom: 0;
      }
    }
    .th, .td{
      font-size: 12px;
      color: rgba(0, 1, 10, 0.93);
      background: #fff;
      padding: 6px 8px;
      border-right: @bdc;
      vertical-align: top;
      &:last-child{
        border-right: 0;
      }
    }

    .th, .td-first{
      color: rgba(3, 10, 38, 0.65);
      background: #F4F5F7;
    }
  }
}

.html-is-pc{
  .table-msg .table{
    .th, .td{
      padding: 12px 8px;
      font-size: 14px;
    }
  }
}

.pc.pc-not-frame {
  .table-msg .table{
    .th, .td{
      font-size: 15px;
    }
  }
}
</style>
